// app/shared/ui-models/environment.ts

export enum Environment {
  Production = 'PRODUCTION',
  Test = 'TEST',
  Staging = 'STAGING',
  Load = 'LOAD',
  Development = 'DEVELOPMENT',
}
